'use client'

import { HistoryContainer } from './history/history.container'

export const DashboardHistory = () => {
  return <HistoryContainer />
}
